const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_content-saver-47/artifacts/a8v7h3xk_Photoroom_20260302_144606.png";
